// extracted by mini-css-extract-plugin
export default {"RecentlyViewed":"styles_RecentlyViewed__XY0Wg","list":"styles_list__-s-yw"};